<template>
    <div v-if="infoList?.length" class="ribbon-container py-2">
      <div v-for="info in infoList" class="info">
        <Icon v-if="info.icon" :type="info.icon"/>
        <p><span class="visually-hidden">{{ info.label }}</span>{{ info.text }}</p>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import Icon from "common/js/vue/image/icon.vue";

export default {
  name: "Ribbon",
  props: {
    apiUrl: String,
    contentId: Number,
    lang: String,
    arProgramsida: Boolean,
    texts: Object,
  },
  data: function () {
    return {
      infoList: [],
    };
  },
  components: {
    Icon,
  },
  created() {
    axios.get(`${this.apiUrl}?contentId=${this.contentId}&lang=${this.lang}`).then((response) => {
      var data = response.data;
      this.infoList = [];
      this.addInfoItemToList(this.texts.typ, data.typ, "fa-book");
      if (this.arProgramsida) {
        this.addInfoItemToList(this.texts.langd, data.langd, "fa-calendar-clock");
      } else {
        this.addInfoItemToList(this.texts.studietakt, data.langd, "fa-clock");
      }
      this.addInfoItemToList(this.texts.studieort, data.studieort, "fa-location-dot");
    }).catch((error) => {
      console.error("Error fetching data:", error);
    });
  },
  methods: {
    addInfoItemToList(label, text, icon) {
      if (text) {
        this.infoList.push({
          label: label,
          text: text,
          icon: icon,
        });
      }
    }
  }
};
</script>